<template>
    <div id="trade">
        <div class="title">交易量统计</div>
        <div class="main mr40">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="查询时间：">
                    <el-date-picker
                        v-model="dateIssued"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="店铺：">
                    <el-select v-model="shopid" placeholder="请选择" @change="selectShop" :loading="getShopLoading">
                        <el-option
                            v-for="item in shopList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品标准名称：">
                    <el-select v-model="standardid" placeholder="请选择" :loading="getStandardLoading">
                        <el-option
                            v-for="item in standardNameList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品名称：">
                    <el-input v-model="goodsName" clearable placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item label="商品ID：">
                    <el-input v-model="goodsids" clearable placeholder="请输入商品ID"></el-input>
                </el-form-item>
                <el-form-item class="mr20">
                    <el-button @click="reset">重置</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search">搜索</el-button>
                </el-form-item>
            </el-form>
            <!-- 搜索区域分割 -->
            <div class="divider"></div>
            <el-table :data="tableData" border style="width: 100%; min-height: 450px;" v-loading="loading">
                <el-table-column prop="title" label="商品名称"> </el-table-column>
                <el-table-column prop="skuName" label="规格"> </el-table-column>
                <el-table-column prop="goodsPrice" label="价格"> </el-table-column>
                <el-table-column prop="orderCount" label="交易次数"> </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="handleSizeChange"
                    :current-page="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    background
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { timeUtils } from '@/utils/time.js'
import { getSessionStorage } from '@/utils/auth.js'
import { standardList, shopList, getGoodsOrderAnalysisList } from '@/api/qualityControl'
export default {
    name: 'trade',
    data () {
        return {
            getStandardLoading: false,
            getShopLoading: false,
            loading: false,
            standardNameList: [],
            standardid: '',
            shopList: [],
            shopid: '',
            dateIssued: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 6), new Date()],
            goodsids: '',
            goodsName: '',
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            tableData: [],
            page: 1,
            size: 10,
            total: 0,
            userid: 0
        }
    },
    methods: {
        sizeChange (size) {
            this.size = size;
            this.search();
        },
        handleSizeChange (page) {
            this.page = page;
            this.search();
        },
        selectShop () {
            this.hasStandard();
        },
        // 搜索
        search () {
            let data = {
                page: this.page,
                size: this.size,
                userid: this.userid,
                starttime: this.dateIssued ? timeUtils(this.dateIssued[0]) : '',
                endtime: this.dateIssued ? timeUtils(this.dateIssued[1]) : '',
                standardid: this.standardid,
                goodsName: this.goodsName,
                goodsids: this.goodsids
            };
            this.query(data);
        },
        // 重置搜索
        reset () {
            this.page = 1; 
            this.size = 10; 
            this.dateIssued = [new Date(new Date().getTime() - 3600 * 1000 * 24 * 6), new Date()];
            this.standardid = ''; 
            this.goodsName = ''; 
            this.goodsids = '';
            this.shopid = '';
            let data = {
                page: 1,
                size: 10,
                userid: this.userid,
                starttime: timeUtils(new Date(new Date().getTime() - 3600 * 1000 * 24 * 6)),
                endtime: timeUtils(new Date()),
                standardid: '',
                goodsName: '',
                goodsids: ''
            };
            this.query(data);
        },
        query (data) {
            this.loading = true;
            getGoodsOrderAnalysisList(data)
                .then(res => {
                    if (res.status == 200) {
                        this.tableData = res.data.data;
                        this.total = res.data.total;
                    } else {
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                    this.$message.error(err.message);
                })
                .finally( _ => {
                    this.loading = false;
                })
        },
        // 获取店铺
        hasShop () {
            this.getShopLoading = true;
            shopList({userid: this.userid})
                .then(res => {
                    if (res.status == 200) {
                        this.shopList = res.data.data;
                    } else {
                        console.log(res.message);
                    }
                })
                .catch(err => {
                    console.log(err.message);
                })
                .finally( _ => {
                    this.getShopLoading = false;
                })
        },
        // 获取商品标准名称
        hasStandard () {
            this.getStandardLoading = true;
            standardList({id: this.shopid})
                .then(res => {
                    if (res.status == 200) {
                        this.standardNameList = res.data.data;
                    } else {
                        console.log(res.message);
                    }
                })
                .catch(err => {
                    console.log(err.message);
                })
                .finally( _ => {
                    this.getStandardLoading = false;
                })
        },
    },
    mounted () {},
    created () {
        if (getSessionStorage('userid')) {
            this.userid = getSessionStorage('userid');
        } else {
            this.$alert('登录信息失效，请退出后重新登录！','提示',{
                confirmButtonText: '确定',
                callback: action => {
                    this.$router.replace({ path: "/login" });
                }
            });
            return
        }
        this.hasShop();
        this.search();
    },
    components: {}
}
</script>

<style lang='scss' scoped>
    .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        font-size: 18px;
        color: #333;
        width: 100%;
        padding: 15px 32px;
    }

    .main {
        box-shadow: 0px 0px 8px 0px rgba(100, 100, 100, 0.17);
        background: #fff;
        margin: 24px;
        padding: 30px;
        padding-bottom: 70px;
        min-width: 1200px;
        span {
            margin-right: 10px;
            ::v-deep .el-input {
                width: 300px;
                display: inline-block;
            }
        }
        .el-cascader {
            ::v-deep .el-input {
                width: 320px !important;
            }
        }
    }

    .table {
        position: relative;
        .el-button {
            position: absolute;
            left: 300px;
            top: 0px;
            z-index: 1;
        }
    }

    .main {
        .el-form {
            display: flex;
            flex-wrap: wrap;
        }
    }
    .mr40 {
        .page {
            margin-top: 12px;
            float: right;
        }
        .el-form-item {
            margin-right: 40px;
        }
        .mr20 {
            margin-right: 10px;
        }
    }

    ::v-deep .el-range-separator {
        padding: 0px;
    }
</style>